import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { DocketService } from 'src/app/api/core/docket/docket.service';
import { WatcherService } from 'src/app/api/utils/watcher/watcher.service';
import { ModalController } from '@ionic/angular';
import { POLL_UPDATE } from 'src/app/api/utils/watcher/watcher-event';

import size from 'lodash/size';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'hub-preservice-alert',
  templateUrl: './preservice-alert.component.html',
  styleUrls: ['./preservice-alert.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreserviceAlertComponent implements OnInit {
  public context: string;

  private _pollCompletedSub: Subscription;

  constructor(
    public watcher: WatcherService,
    public docketService: DocketService,
    public changeRef: ChangeDetectorRef,
    public viewCtrl: ModalController,
  ) {}

  ngOnInit() {
    this._pollCompletedSub = this.watcher
      .on(POLL_UPDATE)
      .pipe(debounceTime(1000))
      .subscribe(() => {
        this.generateContext();
      });

    this.generateContext();
  }

  public generateContext(): void {
    const orderCount: number = size(this.docketService.findAllFutureOrdersForToday());
    this.context = `You have <span class='emp'>${orderCount} Order${
      orderCount > 1 ? 's' : ''
    }</span> for today,<br>would you like to print them?`;
    this.changeRef.detectChanges();
  }

  close(print: boolean): void {
    this.viewCtrl.dismiss({ print: print });
  }

  ngOnDestroy() {
    if (this._pollCompletedSub) {
      this._pollCompletedSub.unsubscribe();
    }
  }
}
